<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1344645" style="color: #82a339"><b>CUBANO QUESADILLAS</b></p>
<p class="ext" id="d7e1345145"><b><i>Our take on the classic pressed sandwich adds a touch of the Southwest. Low-fat tortillas make for a lighter bite with all the flavor of the original.</i></b></p>
<p class="h4" id="d7e1346445" style="color: #496210"><b>Prep: 18 minutes       Cook: 2 minutes</b></p>
<p class="ul" id="d7e1346945">8 (6-inch) low-fat tortillas</p>
<p class="ul" id="d7e1347245">¼ cup yellow mustard</p>
<p class="ul" id="d7e1348145">4 ounces thinly sliced Black Forest ham</p>
<p class="ul" id="d7e1348445">8 sandwich-cut dill pickle slices</p>
<p class="ul" id="d7e1348845">4 ounces thinly sliced roast pork from the deli</p>
<p class="ul" id="d7e1349145">4 ounces thinly sliced part-skim Swiss cheese</p>
<p class="pub" id="d7e1349645" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Prepare outdoor grill for directly grilling over medium heat.</p>
<p class="pub" id="d7e1350645"><span style="color: #c15b49"><b>2.</b></span> Brush 1 side of each tortilla with mustard. Evenly divide ham, pickles, pork, and cheese between 4 tortillas, placing them on top of mustard. Top with remaining tortillas, mustard side down, pressing firmly.</p>
<p class="pub" id="d7e1352545"><span style="color: #c15b49"><b>3.</b></span>With large metal spatula, place quesadillas on hot grill grate and cook 2 to 3 minutes or until tortillas on both sides are browned and Swiss cheese melts, carefully turning quesadillas once. Transfer quesadillas to large cutting board; let stand 1 minute. Cut each quesadilla into 4 wedges to serve. Makes 8 appetizer servings.</p>
<p class="ntx" id="d7e1355145">Each serving (2 wedges) : About 190 calories, 15g protein, 18g carbohydrate, 6g total fat (2g saturated), 1g fiber, 27mg cholesterol, 640mg sodium.</p>
<p class="ser"><img alt="9781618371621_0045_001" src="Images/9781618371621_0045_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e1356645">Cubano Quesadillas</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c36_r1.vue?49443506